<template>
  <div>
    <Spin size="large" fix v-if="loading"></Spin>
    <div class="top">
      <div class="left">
        <div v-if="">
          <Row>
            <Col>
            <span class="wc-head" v-if="userInfo && userInfo.is_private==1">应用信息</span><span
              class="wc-head-time">更新时间：{{update_time}}</span>
            </Col>
          </Row>
          <Divider />
        </div>
        <div class="nav-title">数据统计分析</div>
        <div class="l-content">
          <div class="shop-data">
            <div class="data-item">
              <div class="title">支付订单</div>
              <div class="amount">{{statis.orderNum}}</div>
              <div class="tips">昨日：{{statis.yesOrderNum}}</div>
            </div>
            <div class="data-item">
              <div class="title">支付金额</div>
              <div class="amount">{{statis.money}}</div>
              <div class="tips">昨日：{{statis.yesMoney}}</div>
            </div>
            <div class="data-item">
              <div class="title">浏览量</div>
              <div class="amount">{{statis.visitNum}}</div>
              <div class="tips">昨日：{{statis.yesVisitNum}}</div>
            </div>
            <div class="data-item">
              <div class="title">会员数量</div>
              <div class="amount">{{statis.userNum}}</div>
            </div>
          </div>
          <div class="table-data">
            <div id="echarts" style="width: 400px;height: 180px;"></div>
          </div>
        </div>
        <div class="quick-entry">
          <div class="q-head">
            快捷入口
            <span class="tips">双击卡片可选择删除</span>
          </div>
          <div class="q-cont">
            <div class="cont-item" v-for="(item,index) in quick_entry" :key="index" @dblclick="dele_quick(index)"
              @click="goUrl(item.path)">
              <div class="item-icon" :style="{'background-color': 'rgba('+item.bg_color+',0.2)'}">
                <div class="item-icon-solid" :style="{'background-color': 'rgb('+item.bg_color+')'}"><i class="iconfont"
                    :class="item.icon"></i></div>
              </div>
              <span>{{item.title}}</span>
            </div>
            <div class="cont-item" @click="modal1 = true">
              <Icon type="md-add" style="margin: auto; font-size: initial;"></Icon>
            </div>
            <Modal v-model="modal1" width="1000" title="快捷入口选择" @on-ok="add_quick(this_entry)">
              <div class="q-cont">
                <div class="cont-item" :class="{'add-item': active==key}" v-for="(value,key) in total_entry" :key="key"
                  @click="thisEntry(value,key)">
                  <div class="item-icon" :style="{'background-color': 'rgba('+value.bg_color+',0.2)'}">
                    <div class="item-icon-solid" :style="{'background-color': 'rgb('+value.bg_color+')'}"><i
                        class="iconfont" :class="value.icon"></i></div>
                  </div>
                  <span>{{value.title}}</span>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
      <div class="rigin">
        <div class="message">
          <div class="flex justify-content-between">
            <div class="title">消息通知</div>
            <div class="span-link" @click="read_tips()">全部已读</div>
          </div>
          <div class="tips-tips-array">
            <div v-for="(item,index) in tips_data.data" :key="index" class="tips-item" @click="tips_handle(item)">
              <div class="tips-create-time">{{ item.create_time }}</div>
              <div class="tips-text">{{ item.text }}</div>
              <div style="color: red;flex-shrink: 0;padding-right: 5px;">未读</div>
            </div>
            <Spin fix v-if="tips_loading"></Spin>
          </div>
          <div class="tips-null" v-if="!tips_data.total">暂无消息</div>
          <Page :total="tips_data.total" show-total :page-size="10" v-model="tips_data.page" @on-change="up_page" class="tips-page"></Page>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="b-left">
        <div class="cont">
          <div id="order" style="width: 100%;height: 300px;"></div>
        </div>
      </div>
      <div class="b-right">
        <div class="goods-hot">热销商品排行榜</div>
        <div class="goods-head">
          <div class="goods_ranking">排名</div>
          <div class="goods_thumb">缩略图</div>
          <div class="goods_name">商品名称</div>
          <div class="goods_qty">销量</div>
        </div>
        <div class="goods-item" v-for="(item,key) in goodsItem" :key="key">
          <div class="number">{{item.hotId}}</div>
          <div class="thumb"><img :src="fullImage(item.thumb)" alt="" /></div>
          <div class="name">{{item.name}}</div>
          <div class="qty">{{item.sales_amount}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  var time = null

  export default {
    name: 'Index',
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem('userInfo')),
        loading: false,
        modal1: false,
        active: null,
        update_time: '',
        statis: {
          userNum: 0,
          orderNum: 0,
          yesOrderNum: 0,
          money: 0,
          yesMoney: 0,
          visitNum: 0,
          yesVisitNum: 0
        },
        option: {
          title: {
            text: '订单数据统计',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          grid: {
            width: 400,
            height: 180
          },
          series: [{
            name: '订单状态',
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        },
        option2: {
          title: {
            text: '近七日订单'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['商城订单']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            name: '商城订单',
            type: 'line',
            stack: '总量',
            data: []
          }]
        },
        goodsItem: [],
        total_entry: [],
        quick_entry: [],
        this_entry: [],
        //消息通知数据
        tips_data: {
          data: [],
          page: 1,
          total: 0
        },
        ImgUrl: this.ImgUrl,
        tips_loading: false //加载状态
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      // 页面初始化
      init() {
        var _this = this
        this.loading = true
        this.requestApi('/adm/get_welcome_data').then(function(res) {
          if (res.status) {
            _this.statis = res.data.todayNew
            _this.update_time = res.data.update_time
            _this.option.series[0].data = res.data.orderStatis
            _this.quick_entry = res.data.quick_entry ? res.data.quick_entry : []
            _this.total_entry = res.data.total_entry
            _this.option2.xAxis.data = res.data.week_order.date
            _this.option2.series[0].data = res.data.week_order.count
            _this.goodsItem = res.data.goods
            //获取消息通知
            _this.get_adm_tips()
            var chartDom = document.getElementById('echarts')
            var chartDom2 = document.getElementById('order')
            var myChart = echarts.init(chartDom)
            var myChart2 = echarts.init(chartDom2)
            myChart.setOption(_this.option)
            myChart2.setOption(_this.option2)
            _this.loading = false
          }
        })
      },
      // 删除快捷按钮 双击删除
      dele_quick(index) {
        clearTimeout(time); // 取消单击操作
        var _this = this
        this.$Modal.confirm({
          title: '提示',
          content: '确定要删除快捷按钮吗？',
          onOk: () => {
            this.requestApi('/adm/set_welcome_dele_entry', {
              'id': index
            }).then((res) => {
              if (res.status) {
                _this.quick_entry.splice(index, 1)
              } else {
                _this.$Message.error('网络错误')
              }
            })
          }
        })
      },
      // 选择添加的按钮
      thisEntry(value, index) {
        this.this_entry = value
        this.active = index
      },
      // 添加快捷按钮
      add_quick(item) {
        var _this = this
        if (!item) return this.alertErr('请选择快捷入口');
        for (let index in this.quick_entry) {
          if (this.quick_entry[index].id == item.id) return this.alertErr('快捷入口已存在');
        }
        this.requestApi('/adm/set_welcome_add_entry', item).then((res) => {
          if (res.status) {
            _this.quick_entry.push(item);
          } else {
            _this.alertErr('网络错误');
          }
        })
      },
      //获取消息通知
      get_adm_tips() {
        let _this = this
        this.tips_loading = true
        this.requestApi('/adm/get_adm_tips',{page: this.tips_data.page}).then(
          (res) => {
            _this.tips_loading = false
            if(res.code == 200) {
              _this.tips_data.data = res.data.data
              _this.tips_data.total = res.data.total
            }
          }
        )
      },
      //切换消息通知分页
      up_page(page) {
        this.tips_data.page = page
        this.get_adm_tips()
      },
      // 跳转地址
      goUrl(url) {
        clearTimeout(time)
        time = setTimeout(() => {
          this.toUrl(url)
        }, 300)
      },
      //消息提醒跳转
      tips_handle(item) {
        //跳转链接
        this.toUrl(item.link)
        //已读消息
        this.read_tips(item.id)
        this.$store.dispatch("setMenuId",item.menu_1)
        this.$store.dispatch("setMenuSonId",item.menu_2)
      },
      //已读消息
      read_tips(id = 0) {
        let _this = this
        this.requestApi('/adm/read_adm_tips',{id}).then(
          (res) => {
            if(res.code == 200) {
              if(id == 0) {
                _this.alertSucc(res.msg)
                _this.get_adm_tips()
              }
            }else {
              _this.alertErr(res.msg)
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  .top,
  .buttom {
    display: flex;
    flex-wrap: nowrap;
  }

  .top {
    margin-bottom: 12px;
  }

  .top .left {
    padding: 18px;
    background-color: #FFFFFF;
  }

  .tips-create-time {
    color: #9E9E9E;
    white-space: nowrap;
  }

  .tips-tips-array {
    border-top: 1px solid #D9D9D9;
    font-size: 12px;
    padding-top: 10px;
    margin-top: 10px;
    overflow: hidden;
    position: relative;
  }

  .tips-text {
    margin: 0px 10px;
    white-space: nowrap;
  }

  .tips-null {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #D9D9D9;
  }

  .top .left {
    width: 75%;
  }

  .top .rigin {
    width: 25%;
  }

  .top .nav-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .top .left .l-content {
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: nowrap;
  }

  .top .left .l-content .shop-data {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    border-right: 1px solid #eeeeee;
  }

  .top .left .l-content .shop-data .data-item {
    width: 50%;
    margin-bottom: 24px;
  }

  .top .left .l-content .shop-data .data-item .title {
    color: #999999;
    font-size: 12px;
  }

  .top .left .l-content .shop-data .data-item .amount {
    font-size: 24px;
    font-weight: 700;
  }

  .top .left .l-content .shop-data .data-item .tips {
    color: #999999;
  }

  .top .left .l-content .table-data {
    width: 50%;
    padding: 0 40px;
  }

  .top .left .quick-entry {
    padding: 12px 0;
    border-top: 1px solid #eeeeee;
  }

  .top .left .quick-entry .q-head {
    font-size: 18px;
    font-weight: 700;
  }

  .top .left .quick-entry .q-head .tips {
    margin-left: 12px;
    font-size: 12px;
    color: #999999;
    font-weight: 500;
  }

  .q-cont {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
  }

  .cont-item {
    box-sizing: border-box;
    width: 16.66%;
    border: 1px solid #f4f4f4;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    margin-left: -1px;
    margin-top: -1px;
  }

  .cont-item .item-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 85, 127, .2);
    text-align: center;
    line-height: 48px;
    margin-right: 6px;
  }

  .cont-item .item-icon .item-icon-solid {
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    background: #ff557f;
    margin: 6px;
    color: #fff;
  }

  .cont-item .item-icon .item-icon-solid i.icon {
    position: relative;
    top: -12px;
  }

  .add-item {
    background: #f6f6f6;
  }

  .top .rigin {
    margin-left: 12px;
    position: relative;
  }

  .top .rigin .message {
    padding: 18px;
    height: 100%;
    background-color: #FFFFFF;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
  }

  .top .rigin .message .title {
    font-size: 18px;
    font-weight: 700;
  }

  .top .rigin .h5 {
    height: 50%;
    padding-top: 18px;
    box-sizing: border-box;
  }

  .top .rigin .h5 .cont {
    padding: 18px;
    height: 100%;
    background-color: #FFFFFF;
  }

  .top .rigin .h5 .cont .title {
    font-size: 18px;
    font-weight: 700;
  }

  .buttom .b-left {
    width: 75%;
    padding: 18px;
    background-color: #FFFFFF;
  }

  .buttom .b-left .cont {
    width: 100%;
    height: 300px;
  }

  .buttom .b-right {
    width: 25%;
    padding: 18px;
    margin-left: 12px;
    background-color: #FFFFFF;
  }

  .buttom .b-right .goods-hot {
    font-size: 18px;
    font-weight: 700;
  }

  .goods-head {
    display: flex;
    flex-wrap: nowrap;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    border-bottom: 1px solid #eeeeee;
  }

  .goods-head .goods_ranking {
    width: 40px;
    text-align: center;
    flex-shrink: 0;
  }

  .goods-head .goods_thumb {
    width: 50px;
    height: 32px;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .goods-head .goods_name {
    flex: 2;
    min-width: 65px;
    flex-shrink: 0;
  }

  .goods-head .goods_qty {
    flex: 1;
    min-width: 60px;
    text-align: right;
    flex-shrink: 0;
  }

  .goods-item {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 50px;
    line-height: 40px;
    padding: 5px 0px;
    font-size: 12px;
    border-bottom: 1px solid #eeeeee;
  }

  .goods-item .number {
    flex-shrink: 0;
    width: 40px;
    text-align: center;
  }

  .goods-item .thumb {
    flex-shrink: 0;
    width: 50px;
    height: 40px;
    margin-right: 10px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .goods-item .thumb img {
    width: 34px;
    height: 34px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .goods-item .name {
    flex: 2;
    min-width: 65px;
    color: #999999;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .goods-item .qty {
    flex: 1;
    text-align: right;
    min-width: 60px;
  }

  .iconfont {
    margin-right: 0px;
  }

  .wc-head {
    padding: 16px 0;
    margin-right: 15px;
  }

  .wc-head-time {
    font-size: 12px;
    color: #999;
  }

  .tips-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 13px 0px;
    cursor: pointer;
  }

  .tips-page {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/public/welcome.vue